import React, { useEffect, useState } from 'react';
import { AdminCouponDto, AdminCouponRequestDto, AdminVoucherDto, AdminVoucherRequestDto } from 'services/data-contracts';
import { FormFieldType, InputField, useModelStateContext } from 'saladsoft-primitive';

import { useStoreWrapper } from 'stores/StoreHelper';
import { toast } from 'react-toastify';
import SaladForm from '../tables/SaladForm';
import { DatePicker } from 'components/commons/DatePicker';
import { DateRangePicker } from 'components/commons/DateRangePicker';
import AllListings from 'components/pages/management/AllListings';
import ServiceHelper from 'stores/ServiceHelper';
import LocalizeInput from 'components/input/LocalizeInput';


interface AdminCouponRequestModel extends AdminCouponRequestDto {
    usePeriod?: boolean;
    period?: string[]
}
const CouponEdit = ({ coupon, categoryId }: { coupon?: AdminCouponDto, categoryId?: number }) => {
    const { uiStore } = useStoreWrapper();
    const { setMultipleState, unmountModel } = useModelStateContext<AdminCouponRequestModel>();

    const [isLoaded, setIsLoaded] = useState(false);

    const columns: FormFieldType<AdminCouponRequestModel>[] = [
        {
            label: "쿠폰명",
            key: "localizedName",
            validation: "required",
            controlType: "custom",
            template: <LocalizeInput />,
            group: { id: "name", groupSeq: 1, seq: 1 },

        },
        {
            label: "쿠폰설명",
            key: "localizedDesc",
            validation: "required",
            controlType: "custom",
            template: <LocalizeInput />,
            group: { id: "name", groupSeq: 1, seq: 2 },

        },
        {
            label: "쿠폰 유형",
            key: "discountType",
            controlType: "select",
            defaultIndex: 0,
            options: [
                { label: "할인율", value: "PERCENT" },
                { label: "할인금액", value: "FIXED" },
            ],
            validation: "required",
            group: { id: "voucherType", groupSeq: 2, seq: 1 },
        },

        { label: "할인율", key: "price", controlType: "number", dependsOn: "discountType", dependsOnValue: "PERCENT", group: { id: "voucherType", groupSeq: 2, seq: 2 } },
        { label: "할인금액", key: "price", controlType: "number", dependsOn: "discountType", dependsOnValue: "FIXED", group: { id: "voucherType", groupSeq: 2, seq: 2 } },

        { label: '만료일', key: 'expireDate', controlType: 'custom', template: <DatePicker />, group: { id: "qtyGroup", groupSeq: 3, seq: 2 } },

        {
            label: "숙박기간",
            key: "usePeriod",
            controlType: "select",
            defaultIndex: 0,
            options: [
                { label: "적용", value: "APPLY" },
                { label: "미적용", value: "NOT_APPLY" },
            ],
            group: { id: "name", groupSeq: 4, seq: 1 },
        },
        {
            label: "기간", key: "period", controlType: 'custom', template: <DateRangePicker />, dependsOn: "usePeriod", dependsOnValue: "APPLY", group: { id: "type", groupSeq: 4, seq: 2 }
        },
        {
            label: "대상 숙소", key: "listingIds", controlType: 'custom', template: <AllListings />, group: { id: "type", groupSeq: 5, seq: 3 }
        },

    ]

    const values = {
        discountType: 'PERCENT' as const,
    }


    const handleUpdate = async (model?: AdminCouponRequestModel) => {
        if (!model) {
            return;
        }
        const newModel = { ...model };
        delete newModel.usePeriod;
        newModel.stayStartDate = model.period?.[0];
        newModel.stayEndDate = model.period?.[1];
        let result;
        if (coupon?.id) {
            result = await ServiceHelper.adminCouponService?.updateCoupon(coupon?.id, newModel as AdminCouponDto);
        } else {
            const newModel = { ...model, isActive: true }
            result = await ServiceHelper.adminCouponService?.createCoupon(newModel as AdminCouponDto);

        }
        if (result?.status === 200) {
            toast.success(`쿠폰이 ${coupon?.id ? '수정' : '추가'}되었습니다.`);
            uiStore?.modal.confirm();
        }
        else {
        }
    }

    useEffect(() => {
        if (isLoaded) {
            return;
        }
        if (coupon) {
            const newModel = { ...coupon };
            const period = [newModel.stayStartDate, newModel.stayEndDate].filter((date): date is string => date !== undefined);
            const listingIds = newModel.listings?.map(l => l.id).filter((id): id is number => id !== undefined);
            setMultipleState({ ...newModel, period, listingIds });
            setIsLoaded(true);
        }
        return () => {
            unmountModel();
        }
    }, [coupon]);

    return <div style={{ paddingBottom: 40, padding: 20 }}>
        <div>
            <SaladForm fields={columns} onSave={handleUpdate} values={values} />
        </div>
    </div>;
};

export default CouponEdit;
